export const timeAgo = (dateString) => {
  const now = new Date();
  const date = new Date(dateString);
  const seconds = Math.floor((now - date) / 1000);

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
  };

  if (seconds < 60) return "الآن";

  for (const [unit, value] of Object.entries(intervals)) {
    const interval = Math.floor(seconds / value);
    if (interval >= 1) {
      switch (unit) {
        case "year":
          return `منذ ${interval} سنة${interval > 1 ? "ت" : ""}`;
        case "month":
          return `منذ ${interval} شهر${interval > 1 ? "ًا" : ""}`;
        case "week":
          return `منذ ${interval} أسبوع${interval > 1 ? "ات" : ""}`;
        case "day":
          return `منذ ${interval} يوم${interval > 1 ? "ًا" : ""}`;
        case "hour":
          return `منذ ${interval} ساعة${interval > 1 ? "ً" : ""}`;
        case "minute":
          return `منذ ${interval} دقيقة${interval > 1 ? "ً" : ""}`;
        default:
          return "الآن";
      }
    }
  }
};
